import { IAddToPoProduct } from '@/models/add_to_po';

/**
 * Adapts a row from the Supplier Detail products table into the
 * page-agnostic IAddToPoProduct contract consumed by AddToPoDrawer.
 *
 * The Supplier Detail view is scoped to a SINGLE supplier (the page
 * context), so the adapter takes the supplier as a second argument
 * rather than inferring it from per-row fields. Rows in this view
 * carry a `supplier` string that just mirrors the page supplier's
 * name; we prefer the explicit page supplier to avoid ambiguity.
 */
export function supplierDetailRowToAddToPoProduct(
  row: any,
  supplier: { id: number | string; name: string } | null = null,
): IAddToPoProduct {
  const rawId = supplier?.id;
  const isUnknown =
    rawId == null || rawId === 'unknown' || rawId === '-' || rawId === '';
  const parsedId = isUnknown ? null : Number(rawId);
  const supplierId = Number.isFinite(parsedId as number) ? parsedId : null;

  return {
    variantId: Number(row.variant_id ?? row.variantId),
    supplierId,
    supplierName: supplierId == null ? null : (supplier?.name || null),
    productName:
      row['Item[Item Description]']
      || row.productName
      || row.product_name
      || 'Unknown Product',
    variant: row.variant || row.variantTitle || '',
    sku: row.product_sku || row.sku || '',
    supplierSku: row.supplier_sku || row.supplierSku || '',
    variantImage: row.image || row.variant_image || row.variantImage,
    suggestedQuantity: Number(
      row['[min_order_quantity]']
      || row.minimum_order_quantity
      || row.min_order_quantity
      || row.reorderQuantity
      || row.orderQuantity
      || 1,
    ),
    // US-CURR-013: supplier-products rows carry SupplierProduct.cost, which is already
    // in the supplier's currency — the drawer must NOT convert it.
    suggestedUnitPrice: Number(row.unit_cost || row.unitCost || row.cost) || 0,
    costSourceCurrency: 'supplier',
    source: 'supplier_detail',
  };
}
